import DOMPurify from "dompurify";

// Strict allow-list for CMS-style notes. Admin-authored only, but defense in depth.
const ALLOWED_TAGS = [
  "p", "br", "hr",
  "strong", "b", "em", "i", "u", "s", "code",
  "h1", "h2", "h3", "h4",
  "ul", "ol", "li",
  "a", "blockquote", "span",
];
const ALLOWED_ATTR = ["href", "title", "target", "rel"];

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    // Force external links to be safe
    ADD_ATTR: ["target", "rel"],
  });
}
